module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return (_vm.loading || _vm.isLoadingProgress) ? _c('loading') : _c('div', {
    staticClass: "students-overview"
  }, [_c('header', {
    staticClass: "page-header page-header--students"
  }, [_c('a', {
    staticClass: "tag button-timid left button--show-planning print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showGroupSettings(_vm.group)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--settings-dark"
  }), _vm._v(" Planning aanpassen")]), _c('h1', [_vm._v("klas " + _vm._s(_vm.group.name))]), _c('hr')]), _c('div', {
    staticClass: "page-content print-hide"
  }, [_c('term-nav', {
    attrs: {
      "terms": _vm.terms,
      "currentGroupTermId": _vm.currentGroupTerm.id,
      "selectedGroupTermId": _vm.groupTerm.id
    }
  }), (_vm.students.length === 0 && !_vm.group.archived) ? _c('empty-group-message', {
    attrs: {
      "group": _vm.group
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "progress-overview"
  }, [_c('table', {
    staticClass: "table-header-rotated"
  }, [_c('thead', {
    staticClass: "table__header--rotated"
  }, [_c('tr', [_c('th', {
    staticClass: "table__col--first"
  }), _vm._l((_vm.assignmentCols), function(assignment) {
    return _c('th', {
      staticClass: "table__col-header table__col-header--rotated"
    }, [_c('div', {
      staticClass: "table__col-header-wrap"
    }, [_c('router-link', {
      staticClass: "table__col-header-inner table__link tag",
      class: {
        'period-end': assignment.lastInPeriod
      },
      attrs: {
        "to": {
          name: 'assignment.group',
          params: {
            periodId: assignment.periodId,
            assignmentId: assignment.id
          }
        }
      }
    }, [_vm._v(_vm._s(assignment.title))])], 1)])
  })], 2)]), _c('tbody', [_vm._l((_vm.studentProgress), function(student) {
    return _c('tr', {
      staticClass: "table__row"
    }, [_c('th', {
      staticClass: "table__row-header"
    }, [_c('router-link', {
      staticClass: "table__header-inner table__link tag",
      attrs: {
        "to": {
          name: 'students.period',
          params: {
            periodId: _vm.currentGroupPeriod.id,
            studentId: student.id
          }
        }
      }
    }, [_vm._v(_vm._s(student.name))])], 1), _vm._l((_vm.assignmentCols), function(assignment, i) {
      return _c('td', {
        class: {
          'cell--period-end': assignment.lastInPeriod, 'cell--important': student.progressions[i].isImportant
        }
      }, [_c('a', {
        staticClass: "table__cell-wrap",
        class: 'table__cell-wrap--' + student.progressions[i].tag,
        attrs: {
          "href": "#",
          "title": _vm.translation(student.progressions[i].tag)
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.viewProgress(student.progressions[i])
          }
        }
      }, [_c('div', {
        staticClass: "progress__icon",
        class: 'progress__icon--' + student.progressions[i].tag
      }, [_c('img', {
        staticClass: "inline-icon",
        attrs: {
          "src": _vm.spriteImage,
          "draggable": "false"
        }
      })]), (student.progressions[i].isRetaking || student.progressions[i].hasNew) ? _c('span', {
        staticClass: "progress__attention-icon print-hide",
        class: {
          'progress__attention-icon--retaking': student.progressions[i].isRetaking,
            'progress__attention-icon--retaking-done': student.progressions[i].isRetakingDone,
        }
      }) : _vm._e()])])
    })], 2)
  }), (_vm.students.length === 0) ? _vm._l((3), function(i) {
    return _c('tr', {
      staticClass: "table__row"
    }, [_c('th', {
      staticClass: "table__row-header"
    }, [_c('span', {
      staticClass: "table__header-inner table__link tag"
    }, [_vm._v("Voorbeeld leerling " + _vm._s(i))])]), _vm._l((_vm.assignmentCols), function(assignment, i) {
      return _c('td', {
        class: {
          'cell--period-end': assignment.lastInPeriod
        }
      }, [_c('div', {
        staticClass: "table__cell-wrap"
      }, [_c('div', {
        staticClass: "progress__icon"
      })])])
    })], 2)
  }) : _vm._e()], 2)])]), (_vm.students.length) ? [_c('a', {
    staticClass: "tag button-timid button--show-aggregate print-hide",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showAggregate($event)
      }
    }
  }, [_c('span', {
    staticClass: "icon icon--inline icon--print-dark"
  }), _vm._v(" Voortgang en beoordelingen klas " + _vm._s(_vm.group.name) + " afdrukken "), (_vm.aggregateVisible) ? _c('loading', {
    attrs: {
      "mini": true,
      "inline": true
    }
  }) : _vm._e()], 1), (_vm.aggregateVisible) ? _c('aggregate', {
    staticClass: "aggregate--print-only",
    attrs: {
      "group": _vm.group,
      "students": _vm.students,
      "assignments": _vm.assignments
    },
    on: {
      "load": _vm.printPage
    }
  }) : _vm._e()] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e72748e","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/students/Students.vue
// module id = BOO5
// module chunks = 1